exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-wrepper[data-v-df8a7ed4]{position:fixed;bottom:0;right:0;z-index:100000;padding:15px}.message[data-v-df8a7ed4]{margin:12px;border-radius:13px;padding:5px;color:#fff}.error[data-v-df8a7ed4]{border:solid #e74444;background-color:#e74444}.success[data-v-df8a7ed4]{border:solid #21b97a;background-color:#21b97a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-df8a7ed4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/partials/Messaging.vue
// module id = 578
// module chunks = 187